import * as Request from './request';
import * as Model from './model';
import client from './client';

const countriesGrouped = (): Promise<Model.Countries[]> => {
    return client.get<Model.Countries[]>('countries/grouped')
        .then(res => res.data);
}

const regions = (country: null | number = null, query: string | null = null): Promise<Model.RegionInfo[]> => {
    const params = {
        country,
        query
    };
    return client.get<Model.RegionInfo[]>('regions', { params })
        .then(res => res.data);
}

const subregions = (region: null | number = null, query: string | null = null): Promise<Model.SubregionInfo[]> => {
    const params = {
        region,
        query
    };
    return client.get<Model.SubregionInfo[]>('subregions', { params })
        .then(res => res.data);
}

const appellations = (query: string | null = null): Promise<Model.Appellation[]> => {
    const params = {
        query
    };
    return client.get<Model.Appellation[]>('appellations', { params })
        .then(res => res.data);
}

const classifications = (query: string | null = null): Promise<Model.Classification[]> => {
    const params = {
        query
    };
    return client.get<Model.Classification[]>('classifications', { params })
        .then(res => res.data);
}

const redVarieties = (query: string | null = null): Promise<Model.RedVariety[]> => {
    const params = {
        query
    };
    return client.get<Model.RedVariety[]>('redVarieties', { params })
        .then(res => res.data);
}

const whiteVarieties = (query: string | null = null): Promise<Model.WhiteVariety[]> => {
    const params = {
        query
    };
    return client.get<Model.WhiteVariety[]>('whiteVarieties', { params })
        .then(res => res.data);
}

const photoAdd = (photo: File): Promise<Model.Photo> => {
    const data = new FormData();
    data.append('photo', photo);
    return client.post<Model.Photo>('photos/', data)
        .then(res => res.data);
}

const photoDelete = (id: number, filename: string): Promise<void> => {
    return client.delete(`photos/${id}/${filename}`)
        .then(res => res.data);
}

const wineryAdd = (data: Request.Winery): Promise<Model.Winery> => {
    return client.post<Model.Winery>('wineries', data)
        .then(res => res.data);
}

export const API = {
    country: {
        grouped: countriesGrouped
    },
    region: {
        list: regions
    },
    subregion: {
        list: subregions
    },
    appellation: {
        list: appellations
    },
    classification: {
        list: classifications
    },
    redVariety: {
        list: redVarieties
    },
    whiteVariety: {
        list: whiteVarieties
    },
    photo: {
        add: photoAdd,
        delete: photoDelete
    },
    winery: {
        add: wineryAdd
    }
};



// WEBPACK FOOTER //
// ./src/api/api.ts